exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mint-indicator{transition:opacity .2s linear}.mint-indicator-wrapper{top:50%;left:50%;position:fixed;transform:translate(-50%,-50%);border-radius:5px;background:rgba(0,0,0,.7);color:#fff;box-sizing:border-box;text-align:center}.mint-indicator-top{top:10%;left:50%;position:fixed;display:-ms-flexbox;display:flex;border-radius:20px}.mint-indicator-text{display:block;color:#fff;text-align:center;margin-top:10px;font-size:16px}.mint-indicator-text.is-top{font-size:14px;height:20px;line-height:20px;margin-left:6px;margin-top:0}.mint-indicator-spin{display:inline-block;text-align:center}.mint-indicator-mask{top:0;left:0;position:fixed;width:100%;height:100%;opacity:0;background:transparent}.mint-indicator-enter,.mint-indicator-leave-active{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/bh-mint-ui2/lib/indicator/style.css
// module id = 489
// module chunks = 0